"use strict";
import UniswapXRouterLabel from "components/RouterLabel/UniswapXRouterLabel";
import { Trans } from "react-i18next";
import { ThemedText } from "theme/components";
export default function UniswapXBrandMark({ fontWeight, ...props }) {
  return <UniswapXRouterLabel {...props}><ThemedText.BodySecondary
    fontSize="inherit"
    {...fontWeight === "bold" && {
      fontWeight: 535
    }}
  ><Trans i18nKey="common.uniswapX" /></ThemedText.BodySecondary></UniswapXRouterLabel>;
}
